import React from 'react'
import AcquireWebComponent from '../framework/MaterialUI';
import Creation from '../../containers/Segment/SegmentCreation'
import Confirm from '../../containers/Segment/SegmentConfirm'
import SaveSuccess from '../../containers/Segment/SegmentSaveSuccess'
import SegmentNav from '../framework/SegmentNav'
import { Row, Col } from '../framework/Grid'

class Segment extends AcquireWebComponent {
	getComponent() {
		const {history} = this.props;
		switch (this.props.match.params.step) {
			case "create":
				return <Creation history={history} />
			case "confirm":
				return <Confirm history={history} />
			case "save_success":
				return <SaveSuccess />
			default:
				return ""
		}
	}

	componentWillMount(){
		this.state={
			marginLeft: 0
		}
	}
	
	componentDidMount(){
		const container = document.getElementById("steps-uid-0-t-0")

		this.setState({marginLeft: container ? container.clientWidth / 2 -40 : 0 })
	}

	getNavBar() {
		const ml = '-' + this.state.marginLeft + 'px'
		return ((this.props.location.pathname !== '/segment') && (this.props.match.params.step !== 'save_success')) && (
			<Row>
				<Col xs="7" sm="7" md="7" lg="7" style={{paddingLeft: '0px', marginLeft:ml}}>
					<SegmentNav {...this.props} />
				</Col>
			</Row>
		)
	}

	render() {
		return (
			<div id="Segment" style={{ padding: "0 10%" }}>
				{this.getNavBar()}
				{this.getComponent()}
			</div>
		)
	}
}


export default Segment;


// WEBPACK FOOTER //
// ./src/components/Segment/index.js